<template>
  <div>
    <navbar-component></navbar-component>
    <main>
      <page-header title="Library"
                   :links="[{title:'Home', url:'/'},{title:'Library',url:'/about'},{title:'Library'}]"></page-header>
      <div class="container-2">
        <section class="sidebar">
          <sidebar :active="7"></sidebar>
        </section>
        <section class="content">
          <div class="flex heading-black1 justify-center uppercase font-serif">library committee</div>
          <blockquote class="mt-8 text-gray-600 text-justify font-medium">
            <p>To up to date and maintain institute library as per established standards and to provide quality services
              to all users of library college has constituted Library Advisory Committee.</p>
          </blockquote>
          <div class="space-y-4">
            <div>
              <ul class="w-full text-gray-900 bg-white rounded-lg border border-gray-200 ">
                <li class="py-4 px-4 w-full rounded-t-lg border-b border-gray-200 text-justify hover:text-gray-700 hover:bg-gray-100">
                  <i class="pi pi-arrow-circle-right mr-2"></i> Library Advisory Committee
                </li>
                <li class="py-4 px-4 w-full rounded-t-lg border-b border-gray-200 text-justify hover:text-gray-700 hover:bg-gray-100">
                  <i class="pi pi-arrow-circle-right mr-2"></i> Library Executives Committee
                </li>
              </ul>
            </div>
            <div class="heading-black2 font-serif"> Library Advisory Committee</div>
            <div class="heading-black2 font-serif">Roles and Responsibilities of Library Advisory Committee</div>
            <div>
              <UnorderedList :ItemList="Rules"/>
            </div>
            <div class="heading-black2 font-serif">Constitution of Library Advisory Committee</div>
            <div>
              <UnorderedList :ItemList="constitutions"/>
            </div>
            <div class="heading-black2 font-serif">The composition of Library Advisory Committee</div>
            <div>
              <DataTable :value="Members" :rowHover="true">
                <Column field="no" header="#"></Column>
                <Column field="name" header="Name"></Column>
                <Column field="designation" header="Designation"></Column>
                <Column field="post" header="Post"></Column>
              </DataTable>
            </div>
            <div class="heading-black2 font-serif">Library Executives Committee</div>
            <div class="heading-black2 font-serif">Roles and responsibilities of Library Executives Committee</div>
            <div>
              <UnorderedList :ItemList="ExeRules"/>
            </div>
            <div class="heading-black2 font-serif">Composition of Library Executives Committee</div>
            <div>
              <DataTable :value="ExeMember" :rowHover="true">
                <Column field="no" header="#"></Column>
                <Column field="name" header="Name"></Column>
                <Column field="designation" header="Designation"></Column>
                <Column field="post" header="Post"></Column>
              </DataTable>
            </div>
            <div class="heading-black2 font-serif">Executives of library should define</div>
            <div>
              <dl class="w-full text-gray-900 bg-white rounded-lg border border-gray-200 ">
                <dt class="flex py-4 px-4 w-full rounded-t-lg border-b border-gray-200 hover:text-gray-700 hover:bg-gray-100"
                    v-for="(item,index) in Menus" :key="index">
                  <i class="pi pi-chevron-right"></i> <span class="ml-2">{{ item.title }}</span>
                  <dl class="mt-8 ml-0">
                    <dt class="py-2 w-full"
                        v-for="(stitle,index) in item.subtitle" :key="index">
                      <i class="pi pi-star"></i> <span class="ml-2">{{ stitle }}</span>
                    </dt>
                  </dl>
                </dt>
              </dl>
            </div>
          </div>
        </section>
      </div>
      <programmes></programmes>
    </main>
    <footer-component></footer-component>
  </div>
</template>

<script>
import NavbarComponent from "@/components/Navbar.vue";
import FooterComponent from "@/components/Footer.vue";
import PageHeader from "@/components/PageHeader";
import Sidebar from "@/views/library/Sidebar";
import Programmes from "@/views/about/Programmes";
import UnorderedList from "@/components/UnorderedList"
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';

export default {
  name: "Committee",
  components: {
    Programmes,
    NavbarComponent,
    PageHeader,
    Sidebar,
    FooterComponent, UnorderedList, DataTable, Column,
  },
  setup() {
    const carouselSlides = ["bg-1", "bg-2", "bg-3"];
    return {carouselSlides};
  },
  data() {
    return {
      Rules: [
        'To guide the Librarian in formulating general library policies and regulations which govern the functions of the library.',
        'To formulate policies and procedures for efficient use of Library resources.',
        'To provide uninterrupted access to physical and online information to satisfy the requirements of the learners.',
        'To enrich the various resources of information and knowledge to the learners.',
        'To create the ambience for the learners to maximize the learning by accessing various learning resources.',
        'To define policy for procurement of books and journals and render advice to the purchase committee for library procurements.',
        'To supervise the allocation and utilization of funds for different departments for purchase of books and journals for the library.',
        'To provide and update the resources required to carry out research.',
        'To maintain a separate Digital Library section with good number of computer systems and digital volumes/Journals useful for the readers.',
      ],
      constitutions: [
        'Principal of the College is Chairperson of Committee',
        'One senior faculty as Professor In charge of Library to be nominated by the Principal',
        'One faculty representative from each department',
        'Librarian - Member Secretary',
      ],
      Members: [
        {
          no: 1,
          name: 'Dr.Patil P.M.',
          designation: 'Principal',
          post: 'Chairman'
        },
        {
          no: 2,
          name: 'Prof.Ansari U.S.',
          designation: 'HOD (FE)',
          post: 'Member'
        },
        {
          no: 3,
          name: 'Prof.Gujrathi T.V.',
          designation: 'HOD ( Mechanical)',
          post: 'Member'
        },
        {
          no: 4,
          name: 'Dr.Tapre P.C.',
          designation: 'HOD ( Electrical)',
          post: 'Member'
        },
        {
          no: 5,
          name: 'Prof. Gawali N.B.',
          designation: 'HOD (Civil)',
          post: 'Member'
        },
        {
          no: 6,
          name: 'Prof.Chandgude A.S.',
          designation: 'HOD (Computer)',
          post: 'Member'
        },
        {
          no: 7,
          name: 'Prof.Rokade P.P.',
          designation: 'HOD (IT)',
          post: 'Member'
        },
        {
          no: 8,
          name: 'Prof. Nagare J.P.',
          designation: 'Librarian',
          post: 'Member Secretary'
        }
      ],
      ExeRules: [
        'To understand and solve the problems of all library users for daily transactions.',
        'To consider the suggestions from all users and act accordingly.',
        'To ensure that the students with identity cards alone are permitted to enter the library.',
        'Periodically monitor the Library information management system for traceability of books and journals in the specified racks.',
      ],
      ExeMember: [
        {
          no: 1,
          name: 'Prof.Nagare J.P',
          designation: 'Librarian',
          post: 'Member Secretary'
        },
        {
          no: 2,
          name: 'Mr.Damle A.D',
          designation: 'Librarian',
          post: 'Member'
        },
        {
          no: 3,
          name: 'Mr.Shinde M.V.',
          designation: 'Peon',
          post: 'Member'
        }
      ],
      Menus: [
        {
          title: 'Library membership information.',
          subtitle: null
        },
        {
          title: 'Library services.',
          subtitle:
              ['Circulation',
                'Book bank scheme',
                'Online Database Search Services',
                'E-Journals',
                'E-Library',
                'Internet Search Services',
                'Video Services',
                'Xeroxing',]
        },
        {
          title: ' Library events and exhibitions.',
          subtitle: null
        },
        {
          title: 'Best Practices.',
          subtitle: [
            'Compiling and displaying student and faculty attendances statistics.',
            'Displaying important newspapers clips and innovative articles.',
            'Career and employment opportunities information.',
            'Suggestion box and timely response.',
            'Displaying new arrivals.',
            ' Organizing competitions.',
            'Conducting periodic survey from users.',
            'Supervising utilization of e-library and internet facilities.',
            'In-house publications.',
          ]
        }
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
p {
  margin-bottom: 0.6rem;
}

::v-deep(.p-datatable) {
  .p-datatable-header {
    background: #e6e6e6;
    color: #404040;
  }

  .p-datatable-thead > tr > th {
    background: #e6e6e6;
    color: #404040;
  }
}
</style>
